import * as countdownTimer from '../common/scripts/less-than-an-hour-timer';
import { startUpsalePaymentProcessStripe } from '../stripe';
import { initPaymentFormPrimer, startPaymentProcessPrimer, teardownPrimer } from './primer';
import store from '../store';
import { isVisible } from '../helpers';
import {
  createPaymentInfo,
  getCustomerUuid,
  getHost,
  getQueryParam,
  getUuid,
  hasToOpenDiscount,
  purchasablePath,
  redirectToFinalPage,
  searchPlanDetailsByProviderAndBillingOption,
  setCurrentCustomerProductUuidWhenOfferIsDownsale,
  setCurrentPurchaseUuid,
  setUUID,
  trackEventInGTM,
  Url,
} from '../common';
import { fetcher } from '../fetcher';
import { discountModal } from '../modals/discount';
import { startPaymentProcessBraintree } from '../braintree-drop-in-v1';
import { getValidPromoCode, handlePromoValidityResponse } from './promo-validity-handler';
import { getDiscountFlow } from './discount-flow';
import '../promo-code';
import { getPaymentDetails } from './payment-details';
import { createAdyenSession, startPaymentProcessAdyen, processPaymentFromExternalSystem } from './adyen';
import { getBackEndVars } from './paypal/getVariables';
import { buildPaymentInitializationPayload } from './payment-initialization';
import { buildEvent as buildAddToCartEvent } from '../tracking/events/AddToCart';
import { buildEvent as buildPageViewEvent } from '../tracking/events/PageView';
import { buildEvent as buildInitiateCheckoutEvent } from '../tracking/events/InitiateCheckout';

const { profileInformation } = require('../user');

export const SCROLL_TIME = 500;

export const initializePaymentPage = () => {
  const emailFirstPaymentMethodSelectSection = document.querySelector('#email-first-payment-method-select');
  const emailFormSection = document.querySelector('#email-form');
  const cardPaymentForm = document.querySelector('#card-payment-form');
  const stripeElementsPaymentForm = document.querySelector('#stripe-elements-payment-form');
  const primerPaymentForm = document.querySelector('#primer-checkout-container');
  const adyenView = document.querySelector('#adyen-view');
  const featureSliderSection = document.querySelector('#feature-slider');

  handlePromoValidityResponse();

  if (['#select-payment-method', '#subscription'].indexOf(window.location.hash) > -1) {
    $t(emailFirstPaymentMethodSelectSection).show();
    $t(emailFormSection).hide();
    $t(featureSliderSection).hide();

    let addToCart = buildAddToCartEvent();
    tracking.trackClient(addToCart);
    trackEventInGTM(addToCart);
  }

  if (['#subscription'].indexOf(window.location.hash) > -1) {
    if (document.getElementById('timer-addon')) {
      countdownTimer.startCountdown();
    }
  }

  if (['#select-payment-method'].indexOf(window.location.hash) > -1) {
    if (hasToOpenDiscount()) {
      discountModal();
    }

    countdownTimer.startCountdown();
  }

  if (window.location.hash === '#stripe-card-payment') {
    toggleFixedDiscountTimer();
    $t(stripeElementsPaymentForm).show();
    $t(emailFormSection).hide();
    $t(featureSliderSection).hide();
  }

  if (window.location.hash === '#card-payment') {
    toggleFixedDiscountTimer();
    $t(cardPaymentForm).show();
    $t(emailFormSection).hide();
    $t(featureSliderSection).hide();
  }

  if (window.location.hash === '#primer-card-payment') {
    initPaymentFormPrimer(buildPaymentInitializationPayload({ provider: 'primer' }));
    toggleFixedDiscountTimer();
    $t(primerPaymentForm).show();
    $t(emailFormSection).hide();
    $t(featureSliderSection).hide();
  }

  if (window.location.hash === '#adyen-card-payment') {
    initializeAdyenPayment();
  } else if (window.location.hash.includes('#adyen-card-payment')) {
    const hash = window.location.hash.substring(1);
    const url = window.location.href;

    const params = new URLSearchParams(hash.split('&').slice(1).join('&'));

    const redirectResult = params.get('redirectResult');

    if (redirectResult) {
      const key = '#adyen-card-payment';
      const position = url.indexOf(key);
      const link = position !== -1 ? url.substring(0, position + key.length) : null;
      window.location.href = link;

      initializeAdyenPayment();

      const payload = {
        payment_provider: 'adyen',
        payment_id: redirectResult,
      };

      getPaymentDetails(payload).then(response => {
        if (link && response.status != 'Cancelled' && response.status != 'Error') {
          processPaymentFromExternalSystem();
        }
      });
    }
  }

  function initializeAdyenPayment() {
    createAdyenSession(buildPaymentInitializationPayload({ provider: 'adyen' }));
    toggleFixedDiscountTimer();
    $t(adyenView).show();
    $t(emailFormSection).hide();
    $t(featureSliderSection).hide();
  }

  const queryTrid = getQueryParam('trid');
  if (queryTrid) {
    setAnswer('transaction_id', queryTrid);
  }

  const emailFirstPaymentMethodSelected = document.querySelectorAll('.js-email-first-payment-method-selected');
  emailFirstPaymentMethodSelected.forEach(el => el.addEventListener('click', e => initializePaymentForm(e)));

  const sequentialPaymentButton = document.querySelector('.js-sequence-payment-button');
  sequentialPaymentButton && sequentialPaymentButton.addEventListener('click', e => sequentialPaymentAction(e));

  // Close payment form and show payment page
  const closePaymentFormButton = document.querySelectorAll('.js-close-payment-form');
  closePaymentFormButton.forEach(el => el.addEventListener('click', e => closePaymentFormAction(e)));
};

window.updatePaymentInfo = function (ajaxUrl, paymentMethod, paymentData) {
  const errorLabel = document.querySelector('.js-payment-error-message');
  const emailFirstPaymentMethodSelectSection = document.querySelector('#email-first-payment-method-select');
  const cardPaymentForm = document.querySelector('#card-payment-form');
  const stripeElementsPaymentForm = document.querySelector('#stripe-elements-payment-form');
  errorLabel && (errorLabel.style.display = 'none');

  return new Promise((resolve, reject) => {
    fetcher
      .put(ajaxUrl, paymentData, { Accept: 'application/json', dataType: 'json' })
      .then(data => {
        // Enabled clicking pay button
        const paymentTypeElements = document.querySelectorAll('.paymentType');
        paymentTypeElements.forEach(e => (e.style.pointerEvents = 'auto'));

        setUUID(data.uuid);
        setCurrentPurchaseUuid(data.currentPurchaseUuid);
        let path = purchasablePath();

        if (paymentMethod === 'braintree') {
          history.replaceState(null, null, path + '#card-payment');
          toggleFixedDiscountTimer();
          $t(cardPaymentForm).show();
        } else if (['stripe-elements', 'stripe-pay-button', 'stripe'].includes(paymentMethod)) {
          history.replaceState(null, null, path + '#stripe-card-payment');
          toggleFixedDiscountTimer();
          $t(stripeElementsPaymentForm).show();
        } else if (paymentMethod === 'primer') {
          history.replaceState(null, null, path + '#primer-card-payment');
          toggleFixedDiscountTimer();
          $t('#primer-checkout-container').show();

          initPaymentFormPrimer(buildPaymentInitializationPayload({ provider: 'primer' }));
        } else if (paymentMethod === 'adyen') {
          history.replaceState(null, null, path + '#adyen-card-payment');
          toggleFixedDiscountTimer();
          $t('#adyen-view').show();

          createAdyenSession(buildPaymentInitializationPayload({ provider: 'adyen' }));
        }

        if (!['paypal-smart-button', 'chargebee'].includes(paymentMethod)) {
          $t(emailFirstPaymentMethodSelectSection).hide();
        }

        return resolve(true);
      })
      .catch(res => {
        // Enabled clicking pay button
        const paymentTypeElements = document.querySelectorAll('.paymentType');
        paymentTypeElements.forEach(e => (e.style.pointerEvents = 'auto'));
        if (res.status === 455) {
          window.location.href = getHost();
        } else if (res.status === 403) {
          errorLabel.textContent = res.error;
          errorLabel.style.display = 'block';
        } else {
          redirectToFinalPage();
        }

        return reject(false);
      });
  });
};

export function initializePaymentForm(e) {
  if (!localStorage.getItem('paymentInit')) {
    localStorage.setItem('paymentInit', true);
  }

  const paymentMethod = e.currentTarget.closest('.paymentType')?.dataset.special;
  const ajaxUrl = new Url().build('products', 'contact-info', 'fill', 'email-first');

  let pageView = buildPageViewEvent();
  let initiateCheckout = buildInitiateCheckoutEvent(paymentMethod);

  tracking.trackClient(pageView, initiateCheckout);
  trackEventInGTM(pageView, initiateCheckout);

  // Disabled clicking pay button
  const paymentTypeElements = document.querySelectorAll('.paymentType');
  paymentTypeElements.forEach(e => (e.style.pointerEvents = 'none'));

  let paymentDetails =
    backEndVars.boxSequence !== undefined
      ? backEndVars.paymentDetails[backEndVars.boxSequence]
      : backEndVars.paymentDetails;
  const data = createPaymentInfo(paymentDetails, paymentMethod);
  data.payment_provider = paymentMethod;
  data.checkoutOffer = backEndVars.checkoutOffer;
  data.uuid = getUuid();
  data.utmParams = store.getMarketingInfo('lastUtmParams');
  data.marketing = {
    fbClientId: tracking.getFbClientId(),
    fbClickId: tracking.getFbClickId(),
    twClickId: tracking.getTwClickId(),
    gClickId: tracking.getGClickId(),
  };
  data.promoCode = getValidPromoCode();
  data.discountFlow = getDiscountFlow();
  window.updatePaymentInfo(ajaxUrl, paymentMethod, data);
}

export function sequentialPaymentAction(e) {
  payments.payButton.disable();
  payments.applePayButtons.disable();
  setCurrentPurchaseUuid(backEndVars.purchasableUUID);
  setCurrentCustomerProductUuidWhenOfferIsDownsale();
  let paymentMethod = e.currentTarget.closest('.paymentType').dataset.special;
  let ajaxUrl = new Url().build('products', 'contact-info', 'fill', 'email-first');

  let paymentDetails =
    backEndVars.boxSequence !== undefined
      ? backEndVars.paymentDetails[backEndVars.boxSequence]
      : backEndVars.paymentDetails;
  let data = createPaymentInfo(paymentDetails, paymentMethod);

  let purchasableUUID =
    backEndVars.boxSequence !== undefined
      ? backEndVars.paymentDetails[backEndVars.boxSequence].id
      : backEndVars.purchasableUUID;
  let customerUUID = getCustomerUuid();

  payments.btnLoader.show(paymentMethod.split('-')[0]);
  payments.formLoader.show();

  data.payment_provider = paymentMethod;
  data.uuid = purchasableUUID;
  data.customerUuid = customerUUID;
  data.checkoutOffer = backEndVars.checkoutOffer;
  data.utmParams = store.getMarketingInfo('lastUtmParams');
  data.marketing = {
    fbClientId: tracking.getFbClientId(),
    fbClickId: tracking.getFbClickId(),
    twClickId: tracking.getTwClickId(),
    gClickId: tracking.getGClickId(),
  };

  fetcher.put(ajaxUrl, data, { Accept: 'application/json', dataType: 'json' }).then(async data => {
    setCurrentPurchaseUuid(data.currentPurchaseUuid);
    data = {
      uuid: data.currentPurchaseUuid,
      customerUuid: customerUUID,
      type: backEndVars.type,
      purchasableCategory: backEndVars.purchasableCategory,
      purchasableType: backEndVars.purchasableType,
      checkoutOffer: backEndVars.checkoutOffer,
    };

    if (getProviderType(paymentMethod) === 'stripe') {
      startUpsalePaymentProcessStripe(data);
    } else if (paymentMethod === 'braintree') {
      startPaymentProcessBraintree(data);
    } else if (paymentMethod === 'primer') {
      let bundleElement = document.getElementById('bundle-id');
      let plan = searchPlanDetailsByProviderAndBillingOption(
        paymentDetails.planDetails,
        paymentMethod,
        paymentDetails.planDetails.type,
      );

      data.bundleId = bundleElement != null ? bundleElement.value : null;
      data.amount = plan.amount;
      data.planId = plan.planId;

      startPaymentProcessPrimer(data);
    } else if (paymentMethod === 'adyen') {
      const bundleElement = document.getElementById('bundle-id');
      const plan = searchPlanDetailsByProviderAndBillingOption(
        paymentDetails.planDetails,
        paymentMethod,
        paymentDetails.planDetails.type,
      );

      data.bundleId = bundleElement != null ? bundleElement.value : null;
      data.amount = plan.amount;
      data.planId = plan.planId;

      startPaymentProcessAdyen(data);
    }
  });
}

export function closePaymentFormAction(e) {
  teardownPrimer();

  const emailFirstPaymentMethodSelectSection = document.querySelector('#email-first-payment-method-select');
  toggleFixedDiscountTimer();

  const paymentFormId = e.currentTarget.dataset.paymentFormId;
  paymentFormId && (document.querySelector(paymentFormId).style.display = 'none');
  history.replaceState(null, null, purchasablePath() + '#select-payment-method');

  $t(emailFirstPaymentMethodSelectSection).show();

  if (hasToOpenDiscount()) {
    discountModal();
  }
}

export function toggleFixedDiscountTimer() {
  const fixedHeader = document.querySelector('.sticky-header');
  if (fixedHeader) {
    fixedHeader.style.display === 'none' ? (fixedHeader.style.display = 'flex') : (fixedHeader.style.display = 'none');
  }
}

export const getScrollTop = element => {
  return isVisible(element) ? element.getBoundingClientRect().top + (element.offsetHeight - window.innerHeight) / 2 : 0;
};

document.addEventListener('DOMContentLoaded', initializePaymentPage);
